export default __webpack_public_path__ + "static/media/cloud1.429d3371.svg";